import { useFetchData } from "../../../hooks/useFetch";
import { ApiConfig, API_BRANCH_SETTINGS_ROUTER } from "../../../services/api-config";

/** Phạm vi "Bỏ qua quét sọt/máy giặt" (khớp BE `SKIP_PRODUCTION_SCOPE`) */
export enum SKIP_PRODUCTION_SCOPE {
  ALL = 1,
  SELECTED = 2,
  EXCLUDED = 3,
}

/** Loại danh sách khách (khớp BE `SKIP_PRODUCTION_LIST_TYPE`) — mỗi chế độ dùng danh sách riêng */
export enum SKIP_PRODUCTION_LIST_TYPE {
  INCLUDE = 1,
  EXCLUDE = 2,
}

export interface BranchSettings {
  id: number;
  branch_id: number;
  enable_equipment: number;
  enable_qr_scan: number;
  enable_extended_workflow: number;
  enable_item_classification: number;
  enable_sub_orders: number;
  enable_skip_production: number;
  skip_production_scope?: number;
  qr_required_steps?: number[] | null;
  pickup_accept_timeout_minutes: number;
  created_at: string;
  updated_at: string;
}

export interface UpdateBranchSettingsPayload {
  enable_equipment?: number;
  enable_qr_scan?: number;
  enable_extended_workflow?: number;
  enable_item_classification?: number;
  enable_sub_orders?: number;
  enable_skip_production?: number;
  skip_production_scope?: number;
  qr_required_steps?: number[];
  pickup_accept_timeout_minutes?: number;
}

export interface SkipProductionCustomer {
  id: number;
  customer_id: number;
  customer_name: string;
  customer_phone: string | null;
  created_at: string;
}

const BranchSettingsService = {
  get: () => {
    const { request, baseResponse, loading } = useFetchData.Get<BranchSettings>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (branchId: number) =>
        request({
          endPoint: API_BRANCH_SETTINGS_ROUTER.API_GET(branchId),
        }),
      response: baseResponse,
      loading,
    };
  },

  update: () => {
    const { request, baseResponse, loading } = useFetchData.Post<BranchSettings>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (branchId: number, payload: UpdateBranchSettingsPayload) =>
        request({
          endPoint: API_BRANCH_SETTINGS_ROUTER.API_UPDATE(branchId),
          data: payload,
        }),
      response: baseResponse,
      loading,
    };
  },

  /** Danh sách khách chỉ định / loại trừ "Bỏ qua quét sọt/máy giặt" */
  skipProductionCustomers: () => {
    const { request, loading } = useFetchData.Get<SkipProductionCustomer[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (branchId: number, list_type: SKIP_PRODUCTION_LIST_TYPE) =>
        request({
          endPoint: API_BRANCH_SETTINGS_ROUTER.API_SKIP_PRODUCTION_CUSTOMERS(branchId),
          data: { list_type },
        }),
      loading,
    };
  },

  addSkipProductionCustomers: () => {
    const { request, loading } = useFetchData.Post<SkipProductionCustomer[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (branchId: number, list_type: SKIP_PRODUCTION_LIST_TYPE, customer_ids: number[]) =>
        request({
          endPoint: API_BRANCH_SETTINGS_ROUTER.API_SKIP_PRODUCTION_CUSTOMERS(branchId),
          data: { list_type, customer_ids },
        }),
      loading,
    };
  },

  removeSkipProductionCustomers: () => {
    const { request, loading } = useFetchData.Post<SkipProductionCustomer[]>({
      projectId: ApiConfig.PROJECT_ID.ORDER_SERVICE,
    });
    return {
      fetch: (branchId: number, list_type: SKIP_PRODUCTION_LIST_TYPE, customer_ids: number[]) =>
        request({
          endPoint: API_BRANCH_SETTINGS_ROUTER.API_SKIP_PRODUCTION_CUSTOMERS_REMOVE(branchId),
          data: { list_type, customer_ids },
        }),
      loading,
    };
  },
};

export default BranchSettingsService;
